import { useState, useEffect } from 'react';
import { syncRequests } from '../APIs/SyncRequests';
import { getAllQueued } from '../utils/offlineDb'
import { useTranslation } from 'react-i18next';

function SyncButton() {
  const [count, setCount] = useState(0);
  const { t } = useTranslation();

  useEffect(() => {
    const fetchQueued = async () => {
      const all = await getAllQueued();
      setCount(all.length);
    };

    fetchQueued();
    const interval = setInterval(fetchQueued, 3000);
    return () => clearInterval(interval);
  }, []);

  const handleSync = async () => {
    await syncRequests();
    const all = await getAllQueued();
    setCount(all.length);
  };

  if (count === 0) return null;

  return (
    <button onClick={handleSync}>
      {t("syncRequests", { count })}
    </button>
  );
}

export default SyncButton;
